import { buildScopedI18n } from '../../../../../utils/buildScopedI18n';
import configBusinessEsCL from './locales/es-CL.json';
import configBusinessEnUS from './locales/en-US.json';
import configBusinessPtBR from './locales/pt-BR.json';

export const configBusinessI18n = buildScopedI18n({
  esCL: configBusinessEsCL,
  enUS: configBusinessEnUS,
  ptBR: configBusinessPtBR,
});
